/*!
 * York Haven Scotch — Big Thirst Cart Config v1.0.0
 *
 * Single-product Buy Button setup using Daisy / checkout-6.
 * Hosted on checkout-6.bigthirst.com Content > Files.
 *
 * WordPress / Elementor setup:
 *   Add to site header (Code Snippets plugin, HTML type, site-wide header):
 *   <script src="https://checkout-6.bigthirst.com/cdn/shop/files/york-haven-config.js"></script>
 *
 *   On the target product page, add where the button should render:
 *   <div class="bt-buy-button" data-handle="yorkhaven-12yr-inchgower" data-button-text="Buy Now"></div>
 */

window.BigThirstCartConfig = {
  // Shared Daisy / checkout-6 store
  domain: 'checkout-6.bigthirst.com',
  storefrontAccessToken: '5efd3cc049a7806cad52715bd18cf19c',

  // Single-product embed behavior
  showEmbedPrice: true,

  // Cart copy
  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax &amp; shipping calculated in next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: 'Discounts/Promo Codes Added During Checkout',
  cartNoteLabel: 'Order Note or Personalized Note for Recipient',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  // Fonts
  googleFonts: '',

  // Base theming
  cssVars: [
    '--bt-font: Georgia, Times, serif;',
    '--bt-alt-font: Georgia, Times, serif;',
    '--bt-price-color: #000000;',
    '--bt-price-size: 20px;',
    '--bt-text-color: #000000;',
    '--bt-title-size: 20px;',
    '--bt-title-weight: 600;',
    '--bt-border-color: #c9a45c;',
    '--bt-btn-bg: #c9a45c;',
    '--bt-btn-color: #000000;',
    '--bt-btn-hover-bg: #b08e4b;',
    '--bt-btn-hover-color: #000000;',
    '--bt-btn-px: 34px;',
    '--bt-btn-radius: 3px;',
    '--bt-add-btn-size: 16px;',
    '--bt-toggle-icon-color: #000000;',
    '--bt-toggle-count-color: #000000;',
    '--bt-notice-bold-color: #000000;',
    '--bt-notice-link-color: #b08e4b;',
  ].join(' '),

  // Match current WordPress button treatment as closely as possible.
  customCSS: [
    '.bt-buy-button { max-width: 360px; }',
    '.bt-embed { text-align: left; }',
    '.bt-embed-price { font-family: Georgia, Times, serif !important; font-size: 20px !important; font-weight: 600 !important; line-height: 1.1 !important; color: #000 !important; margin-bottom: 14px !important; }',
    '.bt-qty-wrap { display: none !important; }',
    '.bt-qty-btn, .bt-qty-input { border: 1px solid #c9a45c !important; color: #000 !important; background: #fff !important; box-shadow: none !important; }',
    '.bt-qty-btn { width: 40px !important; height: 42px !important; font-size: 18px !important; }',
    '.bt-qty-input { width: 56px !important; height: 42px !important; font-family: Georgia, Times, serif !important; font-size: 16px !important; font-weight: 600 !important; line-height: 42px !important; }',
    '.bt-add-btn { font-family: Georgia, Times, serif !important; font-size: 16px !important; font-weight: 600 !important; line-height: 16px !important; text-transform: uppercase !important; letter-spacing: 1.1px !important; color: #000 !important; background: linear-gradient(135deg, #c9a45c, #b08e4b) !important; box-shadow: 0 6px 18px rgba(201, 164, 92, 0.35) !important; padding-top: 14px !important; padding-bottom: 14px !important; border: none !important; border-radius: 3px !important; transition: all 0.3s ease !important; }',
    '.bt-add-btn:hover, .bt-add-btn:focus { color: #000 !important; background: linear-gradient(135deg, #d4b06a, #c19a55) !important; transform: translateY(-1px); }',
    '#bt-cart-toggle { border-radius: 3px !important; box-shadow: 0 6px 18px rgba(201, 164, 92, 0.35) !important; }',
    '#bt-cart-drawer .bt-cart-subtotal, #bt-cart-drawer .bt-cart-subtotal * { color: #8c6a2f !important; }',
    '#bt-cart-drawer .bt-line-item-controls { gap: 0 !important; }',
    '#bt-cart-drawer .bt-line-qty-btn { width: 32px !important; height: 32px !important; border: 1px solid #c9a45c !important; color: #000 !important; background: #fff !important; }',
    '#bt-cart-drawer .bt-line-qty { width: 56px !important; height: 32px !important; border-color: #c9a45c !important; color: #000 !important; font-family: Georgia, Times, serif !important; }',
    '#bt-cart-drawer .bt-checkout-btn { font-family: Georgia, Times, serif !important; font-size: 16px !important; font-weight: 600 !important; text-transform: uppercase !important; letter-spacing: 1.1px !important; color: #000 !important; background: linear-gradient(135deg, #c9a45c, #b08e4b) !important; border: none !important; border-radius: 3px !important; box-shadow: 0 6px 18px rgba(201, 164, 92, 0.35) !important; }',
  ].join('\n'),
};

// Load the Big Thirst Cart engine
(function () {
  var s = document.createElement('script');
  s.src = 'https://checkout-6.bigthirst.com/cdn/shop/files/bigthirst-cart.js';
  s.async = true;
  document.head.appendChild(s);
})();
